const washAndFoldMen = [
	{
		id: '2101',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Top Wear (Shirt / T-shirt / Fatua)',
		service: 'Wash And Fold',
		category: 'Means wear',
		price: 40,
		quantity: 1
    },
    
	{
		id: '2102',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Bottom Wear (Trouser / jeans / Pajama)',
		service: 'Wash And Fold',
		category: 'Means wear',
		price: 40,
		quantity: 1
    },
    
	{
		id: '2103',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Blazer / Coat / Jacket',
		category: 'Means wear',
		service: 'Wash And Fold',
		price: 150,
		quantity: 1
    },
    
	{
		id: '2104',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Winter Wear (Sweater / Hoodies)',
		category: 'Means wear',
		service: 'Wash And Fold',
		price: 85,
		quantity: 1
    },
    
	{
		id: '2105',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Home Wear (Sleeping suit / Nightdress)',
		category: 'Means wear',
		service: 'Wash And Fold',
		price: 60,
		quantity: 1
    },
    
	{
		id: '2106',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Jubba / Kabuli suit',
		category: 'Means wear',
		service: 'Wash And Fold',
		price: 60,
		quantity: 1
	},

	{
		id: '2107',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Accessories (Muffler / Scarf / Cap / Tie)',
		category: 'Means wear',
		service: 'Wash And Fold',
		price: 40,
		quantity: 1
	},

	{
		id: '2108',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Top Wear (Waist Coat)',
		category: 'Means wear',
		service: 'Wash And Fold',
		price: 80,
		quantity: 1
	},

	{
		id: '2109',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Inner Wear (Socks / Shorts / Under Garments)',
		category: 'Means wear',
		service: 'Wash And Fold',
		price: 30,
		quantity: 1
    },
    
	{
		id: '2110',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Panjabi',
		category: 'Means wear',
		service: 'Wash And Fold',
		price: 45,
		quantity: 1
    },
    
	{
		id: '2111',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Exclusive Punjabi',
		category: 'Means wear',
		service: 'Wash And Fold',
		price: 120,
		quantity: 1
	},

	{
		id: '2112',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Leather Jacket',
		category: 'Means wear',
		service: 'Wash And Fold',
		price: 450,
		quantity: 1
    },
    
	{
		id: '2113',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Suit (Blazer + Trouser)',
		category: 'Means wear',
		service: 'Wash And Fold',
		price: 210,
		quantity: 1
    },
    
	{
		id: '2114',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Suit (Blazer + Trouser + Waist Coat)',
		category: 'Means wear',
		service: 'Wash And Fold',
		price: 280,
		quantity: 1
    },
    
	{
		id: '2115',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Overcoat / Overall',
		category: 'Means wear',
		service: 'Wash And Fold',
		price: 300,
		quantity: 1
    },
    
	{
		id: '2116',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Sherwani',
		category: 'Means wear',
		service: 'Wash And Fold',
		price: 350,
		quantity: 1
    },
    
	{
		id: '2117',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Shawl',
		category: 'Means wear',
		service: 'Wash And Fold',
		price: 100,
		quantity: 1
	}
];

export default washAndFoldMen;
